// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"bd284eec","129":"f7c9ea5c","277":"e3fa4a53","449":"865b96f4","495":"a952d783","569":"f51d68bd","663":"2991f2c8","852":"e3208008","922":"ba1b8609"}[chunkId] + ".chunk.js";
};